import { render, staticRenderFns } from "./InnovationIdea.vue?vue&type=template&id=dffc6dd2&"
import script from "./InnovationIdea.vue?vue&type=script&lang=js&"
export * from "./InnovationIdea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports